"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanToDownloadBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DownloadQRCode_1 = require("../DownloadQRCode");
const ScanToDownloadCTABanner_module_css_1 = __importDefault(require("./ScanToDownloadCTABanner.module.css"));
const react_intl_1 = require("react-intl");
const DownloadQrCodeWithLogo_1 = require("../DownloadQRCode/DownloadQrCodeWithLogo");
/**
 * Banner that renders QR code for downloading the snapchat app
 */
function ScanToDownloadBanner(props) {
    const { logoUrl, ...qrCodeProps } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { className: ScanToDownloadCTABanner_module_css_1.default.scanToDownloadContainer, children: [!props.disableQRCode && ((0, jsx_runtime_1.jsx)("div", { className: ScanToDownloadCTABanner_module_css_1.default.qrCodeContainer, children: logoUrl ? ((0, jsx_runtime_1.jsx)(DownloadQrCodeWithLogo_1.DownloadQRCodeWithLogo, { logoUrl: logoUrl, ...qrCodeProps })) : ((0, jsx_runtime_1.jsx)(DownloadQRCode_1.DownloadQRCode, { ...qrCodeProps })) })), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "fmgjrl", description: "Text to supplement the QR code for downloading the app", defaultMessage: "Scan to download the mobile App" })] }));
}
exports.ScanToDownloadBanner = ScanToDownloadBanner;
//# sourceMappingURL=index.js.map